import { Address } from './address-with-country.model';

export class JobLocation {
    '@type': string;
    address: Address;
    constructor(address: Address) {
        this['@type'] = 'Place';
        this.address = address;
    }
}
